// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yCBb","col":"styles_col__1cTn8"};